<!-- Keep Alive  -->
<app-generic-table-header [config]="kaHeaderOptions" (refreshEvent)="refreshTable($event)"></app-generic-table-header>

<ng-template #affixTemplate let-row>
  <app-card-table-actions [row]="row" [actions]="keepAliveRowActions" (actionEvent)="onKaAction($event)"
    [breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
</ng-template>

@if (firstKALoad && loadingKADevices) {
<div class="mauto text-center">
  <br />
  <br />
  <br />
  <br />
  <mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
  <br />
  <br />
</div>
} @if (keepAliveData != null && keepAliveData.length > 0) {
<app-card-table #KATable [tableHeaders]="keepAliveTableHeaders" [currentPage]="currentKAPage" [data]="keepAliveData"
  [totalItems]="totalKeepAliveDevices" [options]="keepAliveTableOptions" [enableInfiteScroll]="false"
  [enableTablePagination]="true" [affixTemplate]="affixTemplate" (paginateEvent)="getPagedDevices($event)"
  [breakpoint]="ScreenSize.TABLET" [enableRefresher]="false" (dataRefreshedEvent)="refreshData($event)" [originalStyling]="true">
</app-card-table>
} @if ((keepAliveData == null || keepAliveData.length == 0) && !loadingKADevices) {
<p class="text-align-center">No results were found.</p>
}

<ng-template #sticky> </ng-template>

@if (deviceIds.length > 0 && layoutService.screenSize > ScreenSize.TABLET) {
<span>
  <button class="btn radius-btn secondary-btn" (click)="openLocationRadiusModal()">Set location radius</button>
</span>
}